var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import JsTimeAgo from 'javascript-time-ago';
import { useTranslations } from '.';
import { HydrationWarningGuard } from './hydrationWarningGuard';
import da from 'javascript-time-ago/locale/da';
import de from 'javascript-time-ago/locale/de';
import en from 'javascript-time-ago/locale/en';
import es from 'javascript-time-ago/locale/es';
import fi from 'javascript-time-ago/locale/fi';
import fr from 'javascript-time-ago/locale/fr';
import it from 'javascript-time-ago/locale/it';
import ja from 'javascript-time-ago/locale/ja';
import nb from 'javascript-time-ago/locale/nb';
import nl from 'javascript-time-ago/locale/nl';
import pl from 'javascript-time-ago/locale/pl';
import pt from 'javascript-time-ago/locale/pt';
import ru from 'javascript-time-ago/locale/ru';
import sv from 'javascript-time-ago/locale/sv';
/* eslint-disable no-console */
JsTimeAgo.addLocale(da);
JsTimeAgo.addLocale(de);
JsTimeAgo.addLocale(en);
JsTimeAgo.addLocale(es);
JsTimeAgo.addLocale(fi);
JsTimeAgo.addLocale(fr);
JsTimeAgo.addLocale(it);
JsTimeAgo.addLocale(ja);
JsTimeAgo.addLocale(nb);
JsTimeAgo.addLocale(nl);
JsTimeAgo.addLocale(pl);
JsTimeAgo.addLocale(pt);
JsTimeAgo.addLocale(ru);
JsTimeAgo.addLocale(sv);
export var TimeAgo = function (_a) {
    var date = _a.date;
    var dateWrapper = new Date(date);
    var _b = __read(useTranslations(), 2), locale = _b[1];
    if (dateWrapper.getTime && isNaN(dateWrapper.getTime())) {
        console.error('Invalid date');
        return null;
    }
    var timeAgo = new JsTimeAgo(locale);
    return React.createElement(HydrationWarningGuard, null, timeAgo.format(dateWrapper));
};
export var HumanizeTime = function (_a) {
    var milliseconds = _a.milliseconds, _b = _a.type, type = _b === void 0 ? 'approximate-time' : _b;
    var _c = __read(useTranslations(), 2), locale = _c[1];
    var timeAgo = new JsTimeAgo(locale);
    return (React.createElement(HydrationWarningGuard, null, timeAgo.format(Date.now() - milliseconds, type)));
};
//# sourceMappingURL=time.js.map